// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"267":"33d967d9c794a735","765":"cb8092c01d486a2a"}[chunkId] + ".js";
};